import { Injectable } from '@angular/core';
import { Router, CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { CryptoJsService } from '../services/crypto-js.service';

@Injectable({
  providedIn: 'root'
})
export class AuthGuard implements CanActivate {

  constructor(
    private router: Router,
    private cryptoJsService: CryptoJsService
  ) { }

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {

    const encData = sessionStorage.getItem('dataF') ? JSON.parse(this.cryptoJsService.DecryptSession(sessionStorage.getItem('dataF'))) : null;
    const farmerConfData = encData ? new Map(encData) : new Map();
    let isFarmerLogin = farmerConfData.get('isFarmerLogin') ? farmerConfData.get('isFarmerLogin') : '';

    if (sessionStorage.getItem('token') && isFarmerLogin === '1') {
      return true;
    } else {
      this.router.navigate(['/phone-login'], { queryParams: { returnUrl: state.url } });
      return false;
    }
  }
}
